<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Brochure History</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="loadData($event, false)">
    <ion-refresher-content pullingIcon="caret-down" pullingText="Pull to refresh" refreshingSpinner="circles"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>

  <ion-list *ngIf="listHistory.length" class="list-history">
    <ion-card class="ion-margin-top card-history" *ngFor="let item of listHistory; let i = index">
      <ion-card-header>
        <div class="header">
          <h2 class="title">
            <div class="ico">
              <ion-img src="assets/restaurant.png" />
            </div>
            <p>
              {{ item.nomeCliente }}
              <small><ion-icon name="call"></ion-icon> {{ item.celular }}</small>
            </p>
          </h2>
        </div>
      </ion-card-header>

      <div class="card-body">
        <div class="data">
          <ion-item *ngIf="claim === userType.Caller">
            <ion-icon name="restaurant-spread" slot="start"></ion-icon>
            <ion-label>{{ item.restaurante.nome }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="calendar" slot="start"></ion-icon>
            <ion-label>{{ item.dataCadastro | date: "MM/dd/yyyy h:mm a" }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="ribbon" slot="start"></ion-icon>
            <ion-label>{{ item.pontos }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="cash" slot="start"></ion-icon>
            <ion-label>{{ item.valor | currency }}</ion-label>
          </ion-item>
        </div>
      </div>

    </ion-card>
  </ion-list>

  <div class="ion-padding ion-text-center" *ngIf="!listHistory.length">No results found.</div>

</ion-content>
<app-modal-component *ngIf="showModalEdit && reservSelected" (stateOpen)="showModalEdit = $event">
  <h2 class="title">Select the number of people that should be in this reservation</h2>
  <ion-item>
    <ion-label position="floating">Number People</ion-label>
    <ion-input type="number" [(ngModel)]="selectNumber"></ion-input>
  </ion-item>
  <button class="ion-margin-top button-bigger grey" (click)="confirmEdition()">Confirm Edition</button>
</app-modal-component>

<app-modal-component *ngIf="showModalFilter" (stateOpen)="showModalFilter = $event">
  <form [formGroup]="filterForm">
    <ion-item>
      <ion-label position="floating">Client name</ion-label>
      <ion-input type="text" formControlName="nomeCliente"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">Begin date</ion-label>
      <ion-input type="datetime-local" formControlName="dataInicio"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">End date</ion-label>
      <ion-input type="datetime-local" formControlName="dataFim"></ion-input>
    </ion-item>
  </form>
  <button class="ion-margin-top button-bigger grey" (click)="filterData(null, true)">Search</button>
</app-modal-component>

<ion-fab vertical="bottom" horizontal="end" slot="fixed" size="small">
  <ion-fab-button *ngIf="!isFiltered" color="primary" (click)="showFilter()">
    <ion-icon name="search"></ion-icon>
  </ion-fab-button>
  <ion-fab-button *ngIf="isFiltered" color="primary" (click)="loadData(null, false)">
    <ion-icon name="close"></ion-icon>
  </ion-fab-button>
</ion-fab>
